const environmentData = {
  prod: 'prod',
  pre: 'pre',
  qa: 'qa',
  dev: 'dev',
}

/**
 * Retrieves the environment name based on the provided environment object.
 * @param env - The environment object.
 * @returns The environment name.
 */
function getEnvironmentName(env: Record<string, any>): keyof typeof environmentData {
  const { name } = env
  return Object.prototype.hasOwnProperty.call(environmentData, name) ? environmentData[name] : environmentData.dev
}

export { getEnvironmentName, environmentData }
